export default __webpack_public_path__ + "a3680969ae663a79512a36ca1fd976a1.png";